import React from 'react';

const InfoIcon: React.FC = () => {
  return (
    <svg width="1em" height="1em" viewBox="0 0 12 12" fill="none">
      <path
        d="M6 11C8.76142 11 11 8.76142 11 6C11 3.23858 8.76142 1 6 1C3.23858 1 1 3.23858 1 6C1 8.76142 3.23858 11 6 11Z"
        stroke="#365284"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 8V6"
        stroke="#365284"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 4H6.005"
        stroke="#365284"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default InfoIcon;
